import React from "react";
import { Link } from "react-router-dom";
import { 
  FaFacebookF, 
  FaTwitter, 
  FaLinkedinIn, 
  FaInstagram, 
  FaWhatsapp, 
  FaPhoneAlt, 
  FaEnvelope, 
  FaMapMarkerAlt,
  FaArrowRight,
  FaHeart,
  FaChevronRight
} from "react-icons/fa";
import logo from "../images/logo.png";
import "./Footer.css";

export default function Footer() {
  const year = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="footer-wave-container">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" preserveAspectRatio="none" className="footer-wave">
          <path fill="#ffffff" fillOpacity="1" d="M0,224L48,213.3C96,203,192,181,288,154.7C384,128,480,96,576,106.7C672,117,768,171,864,176C960,181,1056,139,1152,117.3C1248,96,1344,96,1392,96L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
        </svg>
      </div>
      
      <div className="footer-top-bar">
        <div className="container footer-top-content">
          <div className="footer-newsletter">
            <h3>Stay Updated</h3>
            <p>Subscribe to our newsletter for the latest news and updates</p>
          </div>
          <div className="footer-subscription">
            <form className="subscription-form">
              <input type="email" placeholder="Enter your email" className="subscription-input" />
              <button type="submit" className="subscription-button">
                Subscribe <FaArrowRight className="btn-icon" />
              </button>
            </form>
          </div>
        </div>
      </div>
      
      <div className="footer-content container">
        <div className="footer-info" data-aos="fade-up">
          <div className="footer-logo-container">
            <img src={logo} alt="NamStack Logo" className="footer-logo" />
            <div className="footer-logo-text">
              <span className="footer-logo-name">NamStack</span>
              <span className="footer-logo-tagline">Technology Solutions</span>
            </div>
          </div>
          <p className="footer-description">
            NamStack is a Namibian based technology company that ensures quality delivery of products to its clients. 
            We specialize in web development, mobile applications, and custom software solutions.
          </p>
          <div className="footer-social-mini">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon-mini">
              <FaFacebookF />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon-mini">
              <FaTwitter />
            </a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon-mini">
              <FaLinkedinIn />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon-mini">
              <FaInstagram />
            </a>
          </div>
        </div>
        
        <div className="footer-links" data-aos="fade-up" data-aos-delay="100">
          <h3 className="footer-heading">Quick Links</h3>
          <ul className="footer-links-list">
            <li><FaChevronRight className="footer-list-icon" /><Link to="/">Home</Link></li>
            <li><FaChevronRight className="footer-list-icon" /><Link to="/services">Services</Link></li>
            <li><FaChevronRight className="footer-list-icon" /><Link to="/about">About Us</Link></li>
            <li><FaChevronRight className="footer-list-icon" /><Link to="/portfolio">Portfolio</Link></li>
            <li><FaChevronRight className="footer-list-icon" /><Link to="/contact">Contact</Link></li>
          </ul>
        </div>
        
        <div className="footer-services" data-aos="fade-up" data-aos-delay="150">
          <h3 className="footer-heading">Our Services</h3>
          <ul className="footer-links-list">
            <li><FaChevronRight className="footer-list-icon" /><Link to="/services">Web Development</Link></li>
            <li><FaChevronRight className="footer-list-icon" /><Link to="/services">Mobile Applications</Link></li>
            <li><FaChevronRight className="footer-list-icon" /><Link to="/services">Game Development</Link></li>
            <li><FaChevronRight className="footer-list-icon" /><Link to="/services">Graphic Design</Link></li>
            <li><FaChevronRight className="footer-list-icon" /><Link to="/services">Coding Tutorials</Link></li>
          </ul>
        </div>
        
        <div className="footer-contact" data-aos="fade-up" data-aos-delay="200">
          <h3 className="footer-heading">Contact Us</h3>
          <ul className="footer-contact-list">
            <li>
              <div className="contact-icon-wrapper">
                <FaPhoneAlt className="footer-icon" />
              </div>
              <span>+264 81 571 3080</span>
            </li>
            <li>
              <div className="contact-icon-wrapper">
                <FaPhoneAlt className="footer-icon" />
              </div>
              <span>+264 81 589 3187</span>
            </li>
            <li>
              <div className="contact-icon-wrapper">
                <FaEnvelope className="footer-icon" />
              </div>
              <span>info@namstack.com</span>
            </li>
            <li>
              <div className="contact-icon-wrapper">
                <FaMapMarkerAlt className="footer-icon" />
              </div>
              <span>Windhoek, Namibia</span>
            </li>
          </ul>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="container footer-bottom-content">
          <p>Copyright &copy; {year} NamStack | All Rights Reserved</p>
          <p>Made with <FaHeart className="heart-icon" /> by NamStack Developers</p>
        </div>
      </div>
      
      <div className="footer-shapes">
        <div className="footer-shape footer-shape-1"></div>
        <div className="footer-shape footer-shape-2"></div>
        <div className="footer-shape footer-shape-3"></div>
        <div className="footer-shape footer-shape-4"></div>
        <div className="footer-shape footer-shape-5"></div>
        <div className="footer-shape footer-shape-6"></div>
      </div>
    </footer>
  );
}
